package io.github.kingsword09.symbolcraft.symbols.icons.materialsymbols.icons

import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.PathFillType.Companion.NonZero
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.StrokeCap.Companion.Butt
import androidx.compose.ui.graphics.StrokeJoin.Companion.Miter
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.ImageVector.Builder
import androidx.compose.ui.graphics.vector.path
import androidx.compose.ui.unit.dp
import io.github.kingsword09.symbolcraft.symbols.icons.materialsymbols.Icons

public val Icons.FamilyStarW500Rounded: ImageVector
    get() {
        if (_familyStarW500Rounded != null) {
            return _familyStarW500Rounded!!
        }
        _familyStarW500Rounded = Builder(name = "FamilyStarW500Rounded", defaultWidth = 24.0.dp, defaultHeight = 24.0.dp, viewportWidth = 960.0f, viewportHeight = 960.0f).apply {
            path(fill = SolidColor(Color(0xFF000000)), stroke = null, strokeLineWidth = 0.0f, strokeLineCap = Butt, strokeLineJoin = Miter, strokeLineMiter = 4.0f, pathFillType = NonZero) {
                moveTo(565.5f, 617.72f)
                quadToRelative(37.5f, -28.5f, 54.5f, -73.5f)
                lineTo(340.0f, 544.22f)
                quadToRelative(17.0f, 45.0f, 54.5f, 73.5f)
                reflectiveQuadToRelative(85.5f, 28.5f)
                quadToRelative(48.0f, 0.0f, 85.5f, -28.5f)
                close()
                moveTo(422.5f, 468.72f)
                quadToRelative(17.5f, -17.5f, 17.5f, -42.5f)
                reflectiveQuadToRelative(-17.5f, -42.5f)
                quadToRelative(-17.5f, -17.5f, -42.5f, -17.5f)
                reflectiveQuadToRelative(-42.5f, 17.5f)
                quadToRelative(-17.5f, 17.5f, -17.5f, 42.5f)
                reflectiveQuadToRelative(17.5f, 42.5f)
                quadToRelative(17.5f, 17.5f, 42.5f, 17.5f)
                reflectiveQuadToRelative(42.5f, -17.5f)
                close()
                moveTo(622.5f, 468.72f)
                quadToRelative(17.5f, -17.5f, 17.5f, -42.5f)
                reflectiveQuadToRelative(-17.5f, -42.5f)
                quadToRelative(-17.5f, -17.5f, -42.5f, -17.5f)
                reflectiveQuadToRelative(-42.5f, 17.5f)
                quadToRelative(-17.5f, 17.5f, -17.5f, 42.5f)
                reflectiveQuadToRelative(17.5f, 42.5f)
                quadToRelative(17.5f, 17.5f, 42.5f, 17.5f)
                reflectiveQuadToRelative(42.5f, -17.5f)
                close()
                moveTo(300.55f, 250.02f)
                lineTo(412.46f, 105.02f)
                quadToRelative(12.95f, -16.95f, 30.6f, -25.05f)
                quadToRelative(17.64f, -8.1f, 36.89f, -8.1f)
                reflectiveQuadToRelative(36.94f, 8.1f)
                quadToRelative(17.7f, 8.1f, 30.65f, 25.05f)
                lineToRelative(111.91f, 145.0f)
                lineToRelative(169.85f, 57.0f)
                quadToRelative(27.92f, 8.72f, 43.75f, 31.77f)
                quadToRelative(15.84f, 23.06f, 15.84f, 50.49f)
                quadToRelative(0.0f, 12.86f, -3.72f, 25.71f)
                quadToRelative(-3.72f, 12.86f, -12.24f, 24.64f)
                lineTo(763.41f, 595.4f)
                lineToRelative(4.0f, 163.75f)
                quadToRelative(1.0f, 37.32f, -25.03f, 62.91f)
                quadToRelative(-26.03f, 25.59f, -61.14f, 25.59f)
                quadToRelative(-1.76f, 0.0f, -22.24f, -2.76f)
                lineToRelative(-179.0f, -49.76f)
                lineToRelative(-179.0f, 49.76f)
                quadToRelative(-5.24f, 2.0f, -11.24f, 2.5f)
                reflectiveQuadToRelative(-11.24f, 0.5f)
                quadToRelative(-34.77f, 0.0f, -60.85f, -25.67f)
                quadToRelative(-26.08f, -25.68f, -24.84f, -63.07f)
                lineToRelative(4.0f, -164.52f)
                lineToRelative(-109.0f, -155.0f)
                quadToRelative(-8.51f, -11.77f, -12.24f, -24.6f)
                quadToRelative(-3.72f, -12.84f, -3.72f, -25.68f)
                quadToRelative(0.0f, -26.74f, 15.46f, -49.8f)
                quadToRelative(15.45f, -23.05f, 43.37f, -32.53f)
                lineToRelative(169.85f, -57.0f)
                close()
                moveTo(356.15f, 328.11f)
                lineTo(165.74f, 391.39f)
                lineTo(288.3f, 567.04f)
                lineToRelative(-4.23f, 187.42f)
                lineTo(480.0f, 700.65f)
                lineToRelative(196.17f, 54.57f)
                lineToRelative(-4.24f, -188.18f)
                lineToRelative(122.33f, -173.65f)
                lineToRelative(-190.65f, -65.28f)
                lineToRelative(-123.37f, -162.13f)
                lineToRelative(-124.09f, 162.13f)
                close()
                moveTo(480.0f, 460.48f)
                close()
            }
        }
        .build()
        return _familyStarW500Rounded!!
    }

private var _familyStarW500Rounded: ImageVector? = null
